<h3 class="marine-insurance-from-to-note-title">{{ headerTitle | translate }}</h3>
<h4 class="marine-insurance-from-to-note-hint">{{ headerHint | translate }}</h4>

<div class="marine-insurance-from-to-item" [ngClass]="{ 'is-selected': formGroup.get('addressItemType').value === DEFAULT_EMPTY_RADIO }">
  <div class="marine-insurance-from-to-item-header">
    <app-radio-button
      [control]="formGroup.get('addressItemType')"
      [id]="'fromToItem-form'"
      [label]="fromToRadioLabel"
      [value]="DEFAULT_EMPTY_RADIO"
      [name]="'shipment-type'"
    ></app-radio-button>
  </div>
  <div class="marine-insurance-from-to-item-body" [ngClass]="{ 'd-none': formGroup.get('addressItemType').value !== DEFAULT_EMPTY_RADIO }">
    <app-marine-insurance-from-to-form
      [countryFormControl]="countryFormControl"
      [stateFormControl]="stateFormControl"
      [cityFormControl]="cityFormControl"
      [isHideState]="isHideState"
    ></app-marine-insurance-from-to-form>
  </div>
</div>

<div
  class="marine-insurance-from-to-item"
  [ngClass]="{ 'is-selected': formGroup.get('addressItemType').value === fromToItem.fieldToMatch }"
  *ngFor="let fromToItem of fromToItems"
>
  <div class="marine-insurance-from-to-item-header">
    <app-radio-button
      [control]="formGroup.get('addressItemType')"
      [id]="'fromToItem-' + fromToItem.fieldToMatch"
      [label]="radioLabel(fromToItem.label)"
      [value]="fromToItem.fieldToMatch"
      [name]="'shipment-type'"
    ></app-radio-button>
  </div>
  <div class="marine-insurance-from-to-item-body" *ngIf="formGroup.get('addressItemType').value === fromToItem.fieldToMatch">
    <app-marine-insurance-beneficiary-view-data
      [beneficiary]="getFromToData(fromToItem.fieldToMatch)"
      [isShowOnlyAddress]="true"
    ></app-marine-insurance-beneficiary-view-data>
  </div>
</div>

<section class="marine-insurance-from-to-footer">
  <button type="submit" class="btn btn-primary" [disabled]="isSaving" (click)="onSave()">
    {{ "BUTTON.SAVE" | translate }}
  </button>
</section>

<loading-spinner [show]="isSaving"></loading-spinner>
